import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { Add, CalendarMonth } from '@mui/icons-material';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { trackingIconPath } from '../models/TrackingIconForm';
import { GlobalButton, NavigateLinks } from '@/components';
import {
  DESTINATION_ICON_PAGE_NAME,
  DRIVER_ICON_PAGE_NAME,
  liveTrackingChildrenPageBreadcrumbs,
} from '../../config';
import {
  CurrentTrackingIconCard,
  SearchBar,
  TrackingIconsTable,
} from '../components';
import { useTrackingIconFilter } from '../hooks';
import { TRACKING_ICON_SLOTS, TrackingIconSlot } from '../models';

interface TrackingIconsPageProps {
  slot: TrackingIconSlot;
}

const TrackingIconsPage = ({ slot }: TrackingIconsPageProps) => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => liveTrackingChildrenPageBreadcrumbs(navigate),
    [navigate]
  );
  const { initialFilter, filter, setFilter } = useTrackingIconFilter();

  return (
    <section className='flex flex-col w-full h-full gap-6'>
      <NavigateLinks
        actualPage={
          slot === TRACKING_ICON_SLOTS.destination
            ? DESTINATION_ICON_PAGE_NAME
            : DRIVER_ICON_PAGE_NAME
        }
        breadcrumbs={breadcrumbs}
      />
      <div className='flex flex-wrap justify-end gap-3'>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={() =>
            navigate(`/institutional-web/live-tracking/schedule?slot=${slot}`)
          }
        >
          <CalendarMonth />
          Ver programación
        </GlobalButton>
        <GlobalButton
          variant={GlobalButtonVariant.primaryButton}
          action={() => navigate(`${trackingIconPath(slot)}/create`)}
        >
          <Add />
          Crear ícono para{' '}
          {slot === TRACKING_ICON_SLOTS.destination ? 'destino' : 'repartidor'}
        </GlobalButton>
      </div>
      <CurrentTrackingIconCard slot={slot} />
      <SearchBar
        initialFilter={initialFilter}
        filter={filter}
        search={setFilter}
      />
      <TrackingIconsTable filter={filter} slot={slot} />
    </section>
  );
};

export default TrackingIconsPage;
